<template lang="pug">
  server-data(
    v-if="!readOnly"
    :method="$api.tag.index"
    :query="query"
    search-field-name="search[name]"
    @init="resetQuery"
    v-slot="{ selectProps, search, loadMoreItems, loading }"
  )
    v-autocomplete-more(
      v-model="inputValue"
      v-bind="{ ...selectProps, ...$attrs }"
      :search-input.sync="searchInput"
      name="tags"
      label="Метки"
      filled
      rounded
      cache-items
      item-text="name"
      item-value="id"
      @update:search-input="search"
      @load-more-items="loadMoreItems"
    )
      template(#prepend-item)
        v-list-item(
          v-if="searchInput && searchInput.length"
          @click="openCreateTagDialog({ name: searchInput, color: '#FFFFFF' })"
        )
          v-list-item-content Создать тег с названием "{{searchInput}}"
      template(#selection="{ item, index }")
        v-chip(
          v-if="item.color"
          :class="{ 'white--text': invertColor(item.color) }"
          small :color="item.color"
          close
          @click:close="deleteTag(index)"
        ) {{ item.name }}
        span(v-else) {{ item }}
  v-chip-group(
    v-else
    column
  )
    v-chip(
      v-for="tag in value"
      :key="tag.id"
      :color="tag.color"
    ) {{ tag.name }}

</template>
<script>
import CreateTagDialog from '@/modules/Tags/components/CreateTagDialog.vue';
import { invertColor } from '@/utils/color-functions';

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchInput: null,
      query: { 'search[id]': this.value.map((id) => id) },
      menu: false,
      // inputValue: this.value.map(({ id }) => id),
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  // mounted() {
  //   this.query = {};
  // },
  methods: {
    invertColor,
    openCreateTagDialog(initialData = {}) {
      this.$modals.show('generic-controller', {
        title: initialData?.id ? 'Редактирование' : 'Добавить метку',
        component: CreateTagDialog,
        'component-props': {
          initialData,
          save: ({ id }) => {
            const tags = [...this.inputValue];
            tags.push(id);
            this.$set(this, 'inputValue', tags);
            this.query = { 'search[id]': id };
            this.$modals.close();
          },
        },
      });
    },
    deleteTag(idx) {
      const tags = [...this.inputValue];
      tags.splice(idx, 1);
      this.$set(this, 'inputValue', tags);
    },
    resetQuery() {
      this.query = {};
    },
  },
};
</script>
